import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@porchpass/ui";
import { useWorkspace } from "./WorkspaceContext";

export function SyncStatusBanner() {
  const {
    generationError,
    handleGenerate,
    emailStatus,
    emailStatusState,
    emailStatusError,
    refreshEmailStatus,
  } = useWorkspace();

  if (generationError) {
    return (
      <div className="flex items-center justify-between px-6 py-3 bg-[#FEF2F2] text-[#B91C1C] text-sm border-b border-[#FECACA]">
        <div className="flex items-center gap-2">
          <AlertCircle className="h-4 w-4" />
          {generationError}
        </div>
        <Button
          variant="secondary"
          size="s"
          onClick={() => {
            void handleGenerate().catch(() => undefined);
          }}
        >
          <RefreshCw className="h-4 w-4" />
          Retry
        </Button>
      </div>
    );
  }

  if (emailStatusState === "error") {
    return (
      <div className="flex items-center justify-between px-6 py-3 bg-[#FFF7ED] text-[#9A3412] text-sm border-b border-[#FED7AA]">
        <div className="flex items-center gap-2">
          <AlertCircle className="h-4 w-4" />
          {emailStatusError ?? "Unable to load the latest send status."}
        </div>
        <Button
          variant="secondary"
          size="s"
          onClick={() => {
            void refreshEmailStatus().catch(() => undefined);
          }}
        >
          <RefreshCw className="h-4 w-4" />
          Retry
        </Button>
      </div>
    );
  }

  if (emailStatus) {
    return (
      <div className="flex items-center gap-2 px-6 py-3 bg-[#E6F7EE] text-[#1A7F4B] text-sm border-b border-[#B8E6CF]">
        Pre-approval sent
        {emailStatus.sent_on
          ? ` on ${new Date(emailStatus.sent_on).toLocaleDateString()}`
          : ""}
        {` by ${emailStatus.done_by}`}
      </div>
    );
  }

  return null;
}
